export var errorCodes = {
    invalidScope: 'invalid_scope',
    userDeclined: 'user_declined',
    accessDenied: 'access_denied',
    serverError: 'server_error',
    unhandledError: 'Unhandled error:'
};
export var errorCodesNumber = {
    refundInProgress: '600002',
    changeAdress: '600020'
};
export default errorCodes;
